import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useActions } from 'shared/customHooks'
import Folloze from 'folloze-sdk'
import Authorization from './Authorization'
import { setAuthId, fetchCampaign, fetchAccessAuthorization } from 'Authorization/modules/authorization'
import { accessTypeSelector, campaignSelector } from 'Authorization/modules/selectors'
import { getUrlParamValue } from 'shared/helpers/UrlHelper'
import * as authorizationApi from 'Authorization/api/authorization'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'

const AuthorizationContainer = (props) => {
  const [locale, setLocale] = useState('')

  const authorizationType = useSelector(state => accessTypeSelector(state))
  const config = useSelector(state => campaignSelector(state))

  const actions = useActions({
    setAuthId,
    fetchCampaign,
    fetchAccessAuthorization
  }, [])

  useEffect(() => {
    Folloze.initChild()
    const authId = getUrlParamValue(window.location.href, 'auth_id')
    actions.setAuthId(authId)
    fetchLocale(authId)
    actions.fetchCampaign(authId)
    if (isEmpty(authorizationType)) {
      actions.fetchAccessAuthorization(authId)
    }
  }, [])

  const fetchLocale = async (authId) => {
    const data = await authorizationApi.fetchLocale(authId)
    setLocale(data.locale)
  }

  const selectedAuthType = get(authorizationType, 'selected', '')
  const designPageProperties = get(authorizationType, 'design_page_properties', {})

  return (
    <>
      {
        authorizationType && <Authorization
          authorizationType={selectedAuthType}
          locale={locale}
          config={config}
          designPageProperties={designPageProperties} />
      }
    </>
  )
}

export default AuthorizationContainer
